<template>
<div>
<div>
  <v-app id="inspire">
    <v-content>
      <v-container  fluid>
              <div>
              <v-row>
                  <v-col cols="12" md="4">
                    <template>
  <v-card
    class="mx-auto"
    max-width="344"
  >
    <v-card-text>
      <p class="display-1 text--primary">
        Vendas
      </p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        color="deep-purple accent-4"
        @click="relatorio(1,'Vendas')"
      >
      <v-icon> storefront </v-icon>Clique aqui
      </v-btn>
    </v-card-actions>
  </v-card>
  </template>
                  </v-col>

                 <v-col cols="12" md="4">
                    <template>
  <v-card
    class="mx-auto"
    max-width="344"
  >
    <v-card-text>
      <p class="display-1 text--primary">
        Stock
      </p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        color="deep-purple accent-4"
        @click="relatorio(2,'Stock')"
      >
       <v-icon> add_shopping_cart </v-icon>Clique aqui
      </v-btn>
    </v-card-actions>
  </v-card>
  </template>
                  </v-col>
                            <v-col cols="12" md="4">
                    <template>
  <v-card
    class="mx-auto"
    max-width="344"
  >
    <v-card-text>
      <p class="display-1 text--primary">
        Financeiro
      </p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        color="deep-purple accent-4"
        @click="relatorio(3,'Financeiro')"
      >
       <v-icon> credit_card </v-icon>Clique aqui
      </v-btn>
    </v-card-actions>
  </v-card>
  </template>
    </v-col>
     <v-col cols="12" md="4">
    <template>
  <v-card
    class="mx-auto"
    max-width="344"
  >
    <v-card-text>
      <p class="display-1 text--primary">
        Cadastro
      </p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        color="deep-purple accent-4"
        @click="relatorio(4,'Cadastro')"
      >
       <v-icon> person_add </v-icon>Clique aqui
      </v-btn>
    </v-card-actions>
  </v-card>
  </template>
                  </v-col>
     <v-col cols="12" md="4">
    <template>
  <v-card
    class="mx-auto"
    max-width="344"
  >
    <v-card-text>
      <p class="display-1 text--primary">
        Logs do sistema
      </p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        color="deep-purple accent-4"
        @click="relatorio(5,' Logs do sistema')"
      >
       <v-icon> assignment_ind </v-icon>Clique aqui
      </v-btn>
    </v-card-actions>
  </v-card>
  </template>
                  </v-col>
                   <v-col cols="12" md="4">
    <template>
  <v-card
    class="mx-auto"
    max-width="344"
  >
    <v-card-text>
      <p class="display-1 text--primary">
        Contractos
      </p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        color="deep-purple accent-4"
        @click="relatorio(6,'Contractos')"
      >
       <v-icon> assignment </v-icon>Clique aqui
      </v-btn>
    </v-card-actions>
  </v-card>
  </template>
                  </v-col>
                   <v-col cols="12" md="4">
    <template>
  <v-card
    class="mx-auto"
    max-width="344"
  >
    <v-card-text>
      <p class="display-1 text--primary">
        Ordens de Serviço
      </p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        color="deep-purple accent-4"
        @click="relatorio(7,' Ordens de Serviço')"
      >
       <v-icon> business_center </v-icon>Clique aqui
      </v-btn>
    </v-card-actions>
  </v-card>
  </template>
                  </v-col>
                   <v-col cols="12" md="4">
    <template>
  <v-card
    class="mx-auto"
    max-width="344"
  >
    <v-card-text>
      <p class="display-1 text--primary">
        Atendimento
      </p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        color="deep-purple accent-4"
        @click="relatorio(8,'Atendimento')"
      >
       <v-icon> record_voice_over </v-icon>Clique aqui
      </v-btn>
    </v-card-actions>
  </v-card>
  </template>
                  </v-col>
                   <v-col cols="12" md="4">
    <template>
  <v-card
    class="mx-auto"
    max-width="344"
  >
    <v-card-text>
      <p class="display-1 text--primary">
        Agendamento
      </p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        color="deep-purple accent-4"
        @click="relatorio(9,'Agendamento')"
      >
       <v-icon> event_note </v-icon>Clique aqui
      </v-btn>
    </v-card-actions>
  </v-card>
  </template>
                  </v-col>
              </v-row>
               </div>

      </v-container>
    </v-content>

  </v-app>

    </div>
  </div>
</template>

<script>
const ls = require('local-storage')
export default {
  data: () => ({
    ruleTextRequired: [
      value => !!value | 'campo obrigatório.'
    ],
    valid: false,
    isLoading2: false,
    isLoading: true

  }),
  created () {
    this.isLoading = true
  },

  methods: {

    relatorio (tipoRelatorio, descricaoRelatorio) {
      ls.set('relatoriosVendas', { 'tipo': tipoRelatorio, 'descricaoRelatorio': descricaoRelatorio })
      setTimeout(() => {
        if (tipoRelatorio === 4) { this.$router.push('/relatorio_cadastro') } else
        if (tipoRelatorio === 5) { this.$router.push('/logs_sistema') } else {
          if (tipoRelatorio === 1) this.$router.push('/relatorios_vendas')
          else {
            this.$router.push('no-available-2')
          }
        }
      }, 500)
    }
  }
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.progressCircularIsMatriculaURL {
  margin: 1rem;

  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;

}
</style>
